import React from "react";
import { GameShell } from "./layout/GameShell";
import { GamePanel } from "./game/GamePanel";
import { MultiplayerPanel } from "./multiplayer/MultiplayerPanel";

export const App: React.FC = () => {
  return (
    <div className="app-root">
      <GameShell
        left={<GamePanel />}
        right={<MultiplayerPanel />}
      />
    </div>
  );
};


